import './TopNav.scss'

import React from 'react'
import InviteAgentsIcon from './InviteAgentsIcon'
import InviteAdminsIcon from './InviteAdminsIcon'

const EnabledInviteAgentsCard = ({onClickInviteAgents}) => (
  <div className='action-card' onClick={() => onClickInviteAgents()}>
    <InviteAgentsIcon/>
    <h2>Invite Agents</h2>
    <p>To make inviting your agents easier, we have pre-populated agents from Find a Realtor on Realtor.com. Invite new or suggested agents, or search for other agents to join your brokerage on Opcity.</p>
  </div>
)

const DisabledInviteAgentsCard = () => (
  <div className='action-card disabled'>
    <InviteAgentsIcon/>
    <h2>Adding Agents is Paused</h2>
    <p>Adding agents to ReadyConnect Concierge is currently paused and we have removed the waitlist function. To see our full suite of products, <a href="https://succeed.realtor.com/rdcproducts" target="_blank">please visit this page.</a></p>
  </div>
)

const InviteAgentsCard = ({ onClickInviteAgents, InviteAgentsEnabled }) => (
  InviteAgentsEnabled ? <EnabledInviteAgentsCard onClickInviteAgents={onClickInviteAgents} /> : <DisabledInviteAgentsCard />
)

const TopNav = ({ onClickInviteAgents, onClickInviteAdmins, InviteAgentsEnabled }) => {
  return (
    <div id="add-agents-top-nav">
      <InviteAgentsCard
        onClickInviteAgents={onClickInviteAgents}
        InviteAgentsEnabled={InviteAgentsEnabled}
      />
      <div className='action-card' onClick={onClickInviteAdmins}>
        <InviteAdminsIcon/>
        <h2>Invite Admins</h2>
        <p>You can also invite Broker Portal Admins who can<br/> manage other users and track referrals across all<br/> of your agents.</p>
      </div>
    </div>
  )
  }

export default TopNav
